<template>
  <div class="subject">
    <!-- 标题 -->
    <img
      class="subject_background"
      src="../../../static/ningbo/ningbo_log/图形.png"
      alt=""
    />
    <div class="subject_title">
      <div class="subject_title_01">DIY</div>
      <div class="subject_title_02">卡申请</div>
    </div>
    <div class="subject_title_03">自定义卡面，让交通卡成为你的专属出行名片</div>
    <!-- 我的AI世界 -->
    <div class="subject_main_AI">
      <div class="subject_main_title">
        <img
          class="subject_main_title_banckground"
          src="../../../static/ningbo/ningbo_log/图形03.png"
          alt=""
        />
        <div class="subject_main_title_info">我的AI世界</div>
      </div>
      <div class="subject_main_arr">
        <div class="subject_main_arr_01" @click="toMatting()">
          <img
            class="subject_main_arr_01_banckground"
            src="../../../static/ningbo/ningbo_log/图形01.png"
            alt=""
          />
          <div class="title">
            <div class="title_01">一键抠图</div>
            <div class="title_02">“任意照片”一键变卡</div>
            <div class="title_03">→</div>
          </div>
        </div>
        <!-- <div class="subject_main_arr_02" @click="toAIGC()" v-if="false"> -->
        <div class="subject_main_arr_02" @click="toAIGC()">
          <img
            class="subject_main_arr_02_banckground"
            src="../../../static/ningbo/ningbo_log/图形02.png"
            alt=""
          />
          <div class="title">
            <div class="title_01">AIGC人工智能绘画</div>
            <div class="title_02">随心所欲，展现想象</div>
            <div class="title_03">→</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 照片定制 -->
    <div class="subject_main_dingzhi">
      <div class="subject_main_title">
        <img
          class="subject_main_title_banckground"
          src="../../../static/ningbo/ningbo_log/图形03.png"
          alt=""
        />
        <div class="subject_main_title_info">照片定制</div>
      </div>
      <div class="subject_main_arr">
        <div class="subject_main_arr_element">
          <div class="subject_main_arr_element_01" @click="customs()">
            <img
              class="subject_main_arr_background"
              src="../../../static/ningbo/ningbo_log/element_01.png"
            />
            <div class="subject_main_arr_01_01_button">
              <div class="button_left">
                <div class="button_left_01">人物</div>
                <!-- <div class="button_left_02">XXXXXXXXXX</div> -->
              </div>
              <div class="button_right">
                <div>→</div>
              </div>
            </div>
          </div>
          <div class="subject_main_arr_element_01" @click="customs()">
            <img
              class="subject_main_arr_background"
              src="../../../static/ningbo/ningbo_log/element_04.png"
            />
            <div class="subject_main_arr_01_01_button">
              <div class="button_left">
                <div class="button_left_01">城市风景</div>
                <!-- <div class="button_left_02">XXXXXXXXXX</div> -->
              </div>
              <div class="button_right">
                <div>→</div>
              </div>
            </div>
          </div>
        </div>
        <div class="subject_main_arr_element">
          <div class="subject_main_arr_element_01" @click="customs()">
            <img
              class="subject_main_arr_background"
              src="../../../static/ningbo/ningbo_log/element_03.png"
            />
            <div class="subject_main_arr_01_01_button">
              <div class="button_left">
                <div class="button_left_01">国风</div>
                <!-- <div class="button_left_02">XXXXXXXXXX</div> -->
              </div>
              <div class="button_right">
                <div>→</div>
              </div>
            </div>
          </div>
          <div class="subject_main_arr_element_01" @click="customs()">
            <img
              class="subject_main_arr_background"
              src="../../../static/ningbo/ningbo_log/element_02.png"
            />
            <div class="subject_main_arr_01_01_button">
              <div class="button_left">
                <div class="button_left_01">萌宠</div>
                <!-- <div class="button_left_02">XXXXXXXXXX</div> -->
              </div>
              <div class="button_right">
                <div>→</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 图库精选 -->
    <div class="subject_main_tuku" v-if="false">
      <div class="subject_main_title">
        <img
          class="subject_main_title_banckground"
          src="../../../static/ningbo/ningbo_log/图形03.png"
          alt=""
        />
        <div class="subject_main_title_info">图库精选</div>
      </div>
      <div class="subject_main_arr">
        <div class="subject_main_arr_element">
          <div class="subject_main_arr_element_01" @click="fixedCardFace()">
            <img
              class="subject_main_arr_background"
              src="../../../static/ningbo/ningbo_log/element_02.png"
            />
            <div class="subject_main_arr_01_01_button">
              <div class="button_left">
                <div class="button_left_01">人物</div>
                <!-- <div class="button_left_02">XXXXXXXXXX</div> -->
              </div>
              <div class="button_right">
                <div>→</div>
              </div>
            </div>
          </div>
          <div class="subject_main_arr_element_01" @click="fixedCardFace()">
            <img
              class="subject_main_arr_background"
              src="../../../static/ningbo/ningbo_log/element_02.png"
            />
            <div class="subject_main_arr_01_01_button">
              <div class="button_left">
                <div class="button_left_01">城市风景</div>
                <!-- <div class="button_left_02">XXXXXXXXXX</div> -->
              </div>
              <div class="button_right">
                <div>→</div>
              </div>
            </div>
          </div>
        </div>
        <div class="subject_main_arr_element">
          <div class="subject_main_arr_element_01" @click="fixedCardFace()">
            <img
              class="subject_main_arr_background"
              src="../../../static/ningbo/ningbo_log/element_02.png"
            />
            <div class="subject_main_arr_01_01_button">
              <div class="button_left">
                <div class="button_left_01">国风</div>
                <!-- <div class="button_left_02">XXXXXXXXXX</div> -->
              </div>
              <div class="button_right">
                <div>→</div>
              </div>
            </div>
          </div>
          <div class="subject_main_arr_element_01" @click="fixedCardFace()">
            <img
              class="subject_main_arr_background"
              src="../../../static/ningbo/ningbo_log/element_02.png"
            />
            <div class="subject_main_arr_01_01_button">
              <div class="button_left">
                <div class="button_left_01">萌宠</div>
                <!-- <div class="button_left_02">XXXXXXXXXX</div> -->
              </div>
              <div class="button_right">
                <div>→</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="subject_footer">
      <div class="checkProgress" @click="toNingBo()">订单查询</div>
    </div>
    <div class="notice">
      <div class="text">
        用户须知：<font color="#023bb6" @click="showUploadNotice()"
          >《卡面上传图片须知》</font
        >、<font color="#023bb6" @click="showConfirmNotice()"
          >《卡面定制服务确认书》</font
        >、<font color="#023bb6" @click="showPrivacyNotice()"
          >《恒宝DIY卡服务个人信息保护隐私政策》</font
        >、
        <font color="#023bb6" @click="showDIYPrivacy()"
          >《DIY卡片使用须知》</font
        >
      </div>
    </div>
    <div class="version">版本1.0.5</div>
    <!-- 提示 -->
    <b-modal
      ok-only
      ref="model_error"
      title="提示"
      @ok="handleOk"
      ok-title="确定"
    >
      <p class="my-4">{{ hint }}</p>
    </b-modal>

    <b-modal
      ok-only
      ref="model_price_error"
      title="提示"
      @ok="handleprice()"
      ok-title="确定"
    >
      <p class="my-4">价格存在异议！</p>
    </b-modal>
    <b-modal
      ref="model_confirm_notice"
      ok-only
      scrollable
      title="卡面定制服务确认书"
      ok-title="确定"
      centered
    >
      <div>
        <p>
          1.
          本人同意接受宁波公交合作伙伴恒宝股份有限公司提供的卡面定制服务并支付相关服务费用。
        </p>
        <p>
          2.
          本人保证对本人上传的图片拥有知识产权，图片上的人物肖像（如有）为他人肖像的，本人承诺已取得其书面合法授权，
          授权本人和贵行在定制卡面业务中使用其肖像。
          如图片上的人物肖像为未成年人，本人承诺为该未成年人的监护人，授权贵行在定制卡面业务中使用其肖像。
        </p>
        <p>
          3.
          本人知晓并同意定制卡面上传的图片需经过审核通过方可作为卡面使用，本服务提供方有权自主决定审核结果。但审核并不代表对图片肖像权或著作权的认可或承诺。本人知晓并同意，若上传的图片未通过审核，宁波公交有权不予核发。
        </p>
        <p>
          4.
          本人知晓，如因电脑显示、上传等原因产生色差导致卡面效果产生偏差的，以收到卡片实物效果为准。
        </p>
        <p>
          5.
          本人承诺因本人提供的图片侵犯违法违规、第三人合法权利、违反《卡面上传图片须知》中的规则或本承诺等情形而发生的争议，本人自行解决，因此给贵行造成的损失，本人承担损失赔偿责任。
        </p>
        <p>
          6.
          本人知悉并完全理解上述内容，愿意遵守上述约定。如违反上述约定的，本人自愿接受对本人采取的包括但不限于：删除，屏蔽网路信息等必要措施。
        </p>
      </div>
    </b-modal>
    <b-modal
      ref="model_DIY_privacy"
      ok-only
      scrollable
      title="DIY卡片使用须知"
      ok-title="确定"
      centered
    >
      <div>
        <p>一、产品性质</p>
        <p>
          本卡由恒宝股份有限公司提供定制服务，宁波市民卡服务中心监制的DIY定制卡产品。
        </p>
        <p>
          本卡采用交通运输部交通联合（China
          T-union）标准，在本地应用范围包括：公交、轨道交通、城际铁路。可在互联互通城市使用，使用范围可搜索“交通联合官方服务号”的微信服务号查询，互联互通使用时遵照当地规定的使用范围及票价执行。
          本卡为不记名卡，无法挂失，卡片遗失不办理补卡及退款业务。
        </p>
        <p>本卡的卡片费用按产品不同收取工本费，不可退还。</p>
        <p>
          本卡质保期为一年（按卡片开卡之日起计）。质保期内出现卡片无法使用，属于质量问题的（卡片外观完好、卡号清晰且非人为损坏）可按原有版面免费换卡；超过质保期及非质量问题的，可按坏卡退款流程处理。
        </p>
        <p>二、业务受理 1、充值业务</p>
        <p>
          可选择指宁波市民卡服务中心网点充值、至轨道交通站点自助终端设备充值、下载宁波市民卡APP选择“NFC充值”或“补登充值”，具体可详询市民卡服务热线0574-967225。
        </p>
        <p>
          2、正常卡片退款业务
          可持卡和经办人身份证件至宁波市民卡服务中心办理退款业务，退款须全额退还卡内余额，退款后卡暂时冻结，如需再次使用，须至本司自有网点办理启用业务（退款当日不办理启用业务）。
        </p>
        <p>
          3、坏卡处理方法
          坏卡分质量问题、非质量问题，一年内因非人为因素导致卡片芯片损坏，在卡片外观完好卡号清楚的情况下可进行质量问题免费换卡。
          （1）质量问题卡免费换卡业务
          质保期内属于质量问题的坏卡，持卡和经办人身份证件至宁波市民卡服务中心办理质量问题换卡业务，柜面开具业务受理单据并回收坏卡，经办人在登记之日起30天后持受理单据和经办人身份证件至同柜面取卡。
          （2）非质量卡片损坏的退款业务
          超过质保期或属于非质量问题的坏卡，卡片完整且卡号清晰，可持卡和经办人身份证件至宁波市民卡服务中心办理坏卡退款业务，柜面开具业务受理单据并回收坏卡，经办人在登记之日起30天后持受理单据和经办人身份证件至网点退款。
        </p>
      </div>
    </b-modal>
    <b-modal
      ref="model_upload_notice"
      ok-only
      scrollable
      title="卡面上传图片须知"
      ok-title="确定"
      centered
    >
      <div>
        <p>
          上传图片的专利权、版权、人物肖像权（如有，且用户仅能上传本人或未成年子女照片）、
          商标权、著作权等知识产权均由素材提供方负责，并确保该素材不存在任何侵犯第三人合法权利的因素及遵守以下规则：
        </p>
        <p>1. 不与国家法律法规相违背。</p>
        <p>2. 不含煽动或鼓吹反政府,推翻政府的文字或图像。</p>
        <p>3. 不含有与政治主题相关的文字和图像。</p>
        <p>
          4.
          不含有涉及性、血腥、暴力、裸露、不雅主题及其他可被认定为“社会不能接受”相关主题的文字或图像。
        </p>
        <p>5. 不含有涉及种族、宗教、民族、性别歧视主题的文字或图像。</p>
        <p>6. 不含有可能引起公交卡诈骗的文字和图像。</p>
        <p>7. 不含有违反社会主义道德和公序良俗的文字和图像。</p>
        <p>
          8. 不侵害他人肖像权、姓名权、名誉权、隐私权等权利以及他人的知识产权。
        </p>
        <p>9. 不含有侮辱、诽谤或带有歧视性的文字或图像。</p>
        <p>10. 不含有会引起任何人不适的内容。</p>
        <p>
          11.
          不含有任何名牌产品或服务的图片，以及包括这些品牌的缩写、简写或近似的文字或图像。
        </p>
        <p>12. 不含有广告促销及招揽性质的文字或图像。</p>
        <p>
          13.
          不含有容易引发误解的语言或数字，包括电话号码或与服务相关的任何文字或图像。
        </p>
        <p>
          14. 不含有可能在商户受理卡片过程中产生任何误解和混乱的文字或图像。
        </p>
        <p>15.其他不适合作为卡面的文字或图像。</p>
      </div>
    </b-modal>
    <b-modal
      ref="model_privacy_notice"
      ok-only
      scrollable
      title="恒宝 DIY 卡服务个人信息保护隐私政策"
      ok-title="确定"
      centered
    >
      <div>
        <p>重要须知：</p>
        <p>
          恒宝 DIY 卡服务提供者：恒宝股份有限公司（以下简称“恒宝”）
          一贯重视用户个人信息保护，我们将按国家法律法规要求，采取相应的安全保护措施保护您的个人信息安全可控。为此，恒宝通过本《恒宝
          DIY
          卡服务个人信息保护隐私政策》（以下简称“本《隐私政策》”）向您说明您在使用恒宝
          DIY卡服务时，恒宝是如何收集、存储、使用和删除这些信息的，以及向您提供的访问、更新、控制和保护这些信息的方式。本《隐私政策》与您使用恒宝
          DIY
          卡服务息息相关，请您务必仔细阅读、充分理解（未成年人应当在其监护人的陪同下阅读）。
        </p>
        <p>
          您若继续使用恒宝 DIY
          卡服务，即视为您充分理解并完全接受本《隐私政策》；您若对本《隐私政策》有任何疑问、建议，请联系恒宝本地隐私官。
        </p>
        <p>恒宝股份有限公司本地隐私官联系方式：</p>
        <p>中国江苏省丹阳市横塘工业区</p>
        <p>电话（Tel）：0511-86645666</p>
        <p>-------------------------------------------------------</p>
        <p>
          ● 个人信息收集使用规则
          我们所提供的基本业务功能【登录】、【填写邮寄信息】需要收集和使用用户的个人信息
          ● 收集和使用个人信息 ■ 个人信息种类： ◆
          收集登录信息包括：手机号短信验证码 ◆
          收集目的：识别并验证您的身份，以便您可以使用恒宝DIY卡服务；防范、识别和防止欺诈及其他犯罪活动、索赔和其他责任；遵守并执行适用的法律要求、相关行业标准和我们的政策，包括本个人信息保护政策以及恒宝DIY卡服务的条款和条件；以及用于与上述目的相关的其他合理业务用途。
          ◆ 收集邮寄信息包括：收件人姓名、手机号、所在地区、详细地址 ◆
          收集目的：便于制卡完成后的发货，以及物流查询业务 ■
          处理方式：在您使用该服务时，输入个人信息。使用行业标准高强度加密技术存储在中国
          ■ 保存期限：用户删除帐户时或要求删除个人信息时，1天内删除数据
          以上信息对于本服务的运行非常重要。如果您拒绝接受，此类业务功能将无法继续访问。
          ● 我们如何委托处理、共享、转让、公开披露您的个人信息 ■ 委托处理
          某些具体的模块或功能如果由外部供应商提供，我们谨慎选择为我们或代表我们提供服务的供应商。这些提供商也承诺保护您的信息。
          对我们委托处理个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的要求、本个人信息保护政策以及其他任何相关的保密和安全措施来处理个人信息。
          ■ 公开披露 我们仅会在以下情形下，公开披露您的个人信息： a)
          获得您明确同意后； b)
          基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息
          ■ 个人信息的保存期限
          我们保留您的个人信息的时间不会长于使用该信息所需的时间。这意味着，当不再需要该信息时，我们将从系统中销毁或删除它。
          我们采取适当的措施来确保我们根据以下逻辑处理和保留有关您的信息：
          （1）个人信息保存期限应为实现目的所必需的最短时间；
          （2）根据法律、合同或我们的法定义务的要求；
          （3）只保留实现收集、处理信息的目的所必需的时间，但可根据合同、适用法律的需要进行延长，并采取适当的保障措施。
          请参见“个人信息收集使用规则”来查看各项个人信息的具体保存期限。 ●
          Cookies和其他类似技术 ■
          我们以及在我们的服务中提供内容、广告或其他功能的某些第三方，可能会在我们服务的某些领域使用
          Cookie、像素、信标和其他技术。 ■
          Cookies：是在您的计算机、电视、手机或其他设备上存储信息的小文件。它们使将cookies放在设备上的实体能够跨越不同的网站、服务、设备和/或浏览会话中识别您。
          ■ Cookies提供许多有用的用途。例如：Cookies
          可以记住您的登录凭据，以便您不必每次登录服务时都要输入这些凭据。Cookies
          帮助我们和第三方了解我们服务中的哪些部分是最受欢迎的，因为它们有助于我们了解访问者访问的页面和功能以及他们在页面上花费的时间。研究此类信息能够帮助我们更好地适应服务，从而为您提供更好的体验。
          ■ Cookies
          可帮助我们和第三方了解您看过哪些广告，这样您在每次访问服务时就不会收到相同的广告。
          ■
          Cookies通过收集有关您使用我们的服务及其他网站和应用的信息，帮助我们和第三方为您提供相关内容和广告。
          ■ 当您使用 Web 浏览器访问服务时，可以将浏览器配置为接受所有
          Cookies、拒绝所有 Cookies或在发送
          Cookies时通知您。各个浏览器是不同的，所以，请检查浏览器的“帮助”菜单，了解如何更改您的Cookies
          偏好。您的设备的操作系统可能包含对 Cookies 的其他控制。 ■
          请注意，某些服务可能被设计为使用 Cookies 工作，而禁用 Cookies
          可能会影响您使用这些服务或其中某些功能的能力。 ■
          其他本地存储：我们以及某些第三方可能会将我们的服务与其他类型的本地存储技术（例如本地共享对象（也称为“Flash
          Cookies”）和 HTML5 本地存储）结合使用。这些技术类似于上面讨论的
          Cookies。它们存储在您的设备上，可用于存储有关您的活动和偏好的某些信息。但是，这些技术可能通过标准
          Cookies
          利用您的设备的不同部分，因此您可能无法使用标准浏览器工具和设置来控制它们。
          ● 我们如何保护您的个人信息 ■
          我们已使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息。
          ■
          我们会采取一切合理可行的措施，确保未收集无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。
          ■
          互联网环境并非百分之百安全，我们将尽力确保或担保您发送给我们的任何信息的安全性。
          ■
          在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。但我们对因不可抗力、第三方原因或您自身原因导致的信息安全事件不承担责任。
          ● 您的权利 ■
          您可以选择不向我们提供某些类型的信息，例如在注册帐户时不填写某些信息。但在某些情况下，这可能会限制您使用某些服务的能力。当我们询问您的信息时，会尽量解释这些限制，以便您做出明智的决定。按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的个人信息行使以下权利：
          ■
          访问您的个人信息：您有权访问您的个人信息，法律法规规定的例外情况除外。如果您想行使数据访问权，请参见“如何联系我们”部分。我们将在15个工作日内回复您的访问请求。对于您在使用我们的产品或服务过程中产生的其他个人信息，只要我们不需要过多投入，我们会向您提供。如果您想行使数据访问权，请参见“如何联系我们”部分。
          ■
          更正您的个人信息：当您发现我们处理的关于您的个人信息有错误时，您有权要求我们作出更正。您可以通过联系我们的方式提出更正申请。我们将在15个工作日内回复您的更正请求。
          ■ 删除您的个人信息：在以下情形中，您可以向我们提出删除个人信息的请求：
          a) 如果我们处理个人信息的行为违反法律法规； b)
          如果我们收集、使用您的个人信息，却未征得您的同意； c)
          如果我们处理个人信息的行为违反了与您的约定； d)
          如果您不再使用我们的产品或服务，或您注销了账号； e)
          如果我们不再为您提供产品或服务。 ■
          若我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。当您从我们的服务中删除信息后，我们可能不会立即在备份系统中删除相应的信息，但会在备份更新时删除这些信息。
          ● 约束信息系统自动决策 ■
          在某些业务功能中，我们可能仅依据信息系统、算法等在内的非人工自动决策机制作出决定。如果这些决定显著影响您的合法权益，您有权要求我们作出解释，我们也将提供适当的救济方式。
          ● 响应您的上述请求 ■
          为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。 ■
          我们可能会先要求您验证自己的身份，然后再处理您的请求。 ■
          我们将在15个工作日内作出答复。如您不满意，还可以通过“如何联系我们”部分进行投诉。
          ■
          对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。
          ■ 在以下情形中，我们将无法响应您的请求： a)
          与个人信息控制者履行法律法规规定的义务相关的； b)
          与国家安全、国防安全直接相关的； c)
          与公共安全、公共卫生、重大公共利益直接相关的； d)
          与刑事侦查、起诉、审判和执行判决等直接相关的； e)
          个人信息控制者有充分证据表明个人信息主体存在主观恶意或滥用权利的； f)
          出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
          g)
          响应个人信息主体的请求将导致个人信息主体或其他个人、组织的合法权益受到严重损害的；
          h) 涉及商业秘密的。 ● 本政策如何更新 ■
          我们的个人信息保护政策可能变更。 ■
          未经您明确同意，我们不会削减您按照本个人信息保护政策所应享有的权利。我们会在本页面上发布对本政策所做的任何变更。
          ■
          对于重大变更，我们还会提供更为显著的通知（包括对于某些服务，我们会通过电子邮件发送通知，说明个人信息保护政策的具体变更内容）。
          ■ 本政策所指的重大变更包括但不限于： a)
          我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；
          b)
          我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；
          c) 个人信息共享、转让或公开披露的主要对象发生变化； d)
          您参与个人信息处理方面的权利及其行使方式发生重大变化； e)
          我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时； f)
          个人信息安全影响评估报告表明存在高风险时。 g)
          我们还会将本政策的旧版本存档，供您查阅。
        </p>
      </div>
    </b-modal>
  </div>
</template>
<script>
var config = require("@/common/config.js");

export default {
  name: "home_ningbo",
  data() {
    return {
      identification: "", // 宁波银行（三级运行商）判断标识
      pricelog: "", // 宁波银行：价格标识
      price: "", //价格
      hint: "", //提示
      applog: "",
    };
  },
  created() {
    // window.location.reload();
  },
  mounted() {
    this.applog = this.$route.query.applog;
    if (this.applog !== undefined) {
      // applog
      console.log("applog", this.applog);
      localStorage.setItem("applog", this.applog);
    }
    this.identification = this.$route.query.identification;
    if (this.identification !== undefined) {
      // 宁波银行（三级运行商）判断标识
      console.log("identification--->", this.identification);
      localStorage.setItem("identification", this.identification);
      if (this.identification == "ningbo001") {
        localStorage.setItem("bankCode", config.config_nb.bankCode01);
        // localStorage.setItem("bankName", config.config_nb.bankName01);
        console.log("bankCode--->", localStorage.getItem("bankCode"));
      } else if (this.identification == "ningbo002") {
        localStorage.setItem("bankCode", config.config_nb.bankCode02);
        // localStorage.setItem("bankName", config.config_nb.bankName02);
        console.log("bankCode--->", localStorage.getItem("bankCode"));
      } else if (this.identification == "ningbo003") {
        localStorage.setItem("bankCode", config.config_nb.bankCode03);
        // localStorage.setItem("bankName", config.config_nb.bankName03);
        console.log("bankCode--->", localStorage.getItem("bankCode"));
      }
    }
    // 宁波银行：
    this.pricelog = this.$route.query.pricelog;
    if (this.pricelog == undefined) {
      this.pricelog = localStorage.getItem("price_log");
    }
    if (this.pricelog == "nb_a") {
      if (!config.config_nb.isProductMode) {
        // 测试
        this.price = "1";
        localStorage.setItem("price_nb", this.price);
        localStorage.setItem("price_log", this.pricelog);
      }
      if (config.config_nb.isProductMode) {
        // 生产
        this.price = "5000";
        localStorage.setItem("price_nb", this.price);
        localStorage.setItem("price_log", this.pricelog);
      }
    } else {
      this.showErrorPriceMsg();
    }
    console.log("price--->", this.price);
  },
  methods: {
    showErrorPriceMsg: function () {
      this.$refs["model_price_error"].show();
    },
    showErrorMsg: function () {
      this.$refs["model_error"].show();
    },
    handleOk() {},
    handleprice() {
      window.history.go(-1);
    },
    toMatting() {
      // 抠图页面
      this.$router.push({
        name: "selectTopic_ningbo",
      });
    },
    toAIGC() {
      // AI部分
      this.$router.push({
        name: "informationFilling_ai_ningbo",
      });
    },
    customs() {
      // 自定义卡面
      this.$router.push({
        name: "selectCardface_customs_ningbo",
      });
    },
    fixedCardFace() {
      // 自定义卡面
      this.$router.push({
        name: "fixedCardFace_ningbo",
      });
    },
    toNingBo() {
      this.$router.push({
        name: "queryOrder_ningbo",
      });
    },
    showUploadNotice: function () {
      this.$refs["model_upload_notice"].show();
    },
    showConfirmNotice: function () {
      this.$refs["model_confirm_notice"].show();
    },
    showPrivacyNotice: function () {
      this.$refs["model_privacy_notice"].show();
    },
    showDIYPrivacy: function () {
      this.$refs["model_DIY_privacy"].show();
    },
  },
};
</script>

<style lang="less" scoped>
.subject {
  width: 100%;
  height: 82rem;
  background-color: #e4eef8;
  .subject_background {
    width: 100%;
  }
  .subject_title {
    position: absolute;
    top: 2.8rem;
    left: 2rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .subject_title_01 {
      font-size: 2rem;
      font-weight: 800;
      color: #093695;
    }
    .subject_title_02 {
      font-size: 1.8rem;
      font-weight: 800;
    }
  }
  .subject_title_03 {
    position: absolute;
    top: 6rem;
    left: 2.4rem;
    font-size: 0.8rem;
  }
  .subject_main_AI {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 14rem;
    .subject_main_title {
      margin: 0 auto;
      position: relative;
      width: 60%;
      height: 3rem;
      .subject_main_title_banckground {
        width: 100%;
        height: 3rem;
        position: absolute;
        bottom: 0px;
      }
      .subject_main_title_info {
        width: 100%;
        height: 1rem;
        font-size: 1.2rem;
        font-weight: 900;
        font-family: Heiti SC;
        position: absolute;
        top: 0rem;
        left: 30%;
      }
    }
    .subject_main_arr {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      padding: 0 1rem;
      .subject_main_arr_01 {
        width: 48%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .subject_main_arr_01_banckground {
          width: 100%;
          height: 9rem;
        }
        .title {
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          background-color: #ffffff;
          border-radius: 0 0 2rem 2rem;
          padding: 0 0 1rem 1rem;
          .title_01 {
            width: 100%;
            font-size: 0.8rem;
            font-weight: 900;
            padding-bottom: 1rem;
          }
          .title_02 {
            width: 100%;
            font-size: 0.6rem;
            font-weight: 700;
            color: #92969b;
            padding-bottom: 1rem;
          }
          .title_03 {
            width: 2.6rem;
            height: 1.4rem;
            font-size: 0.8rem;
            font-weight: 900;
            color: white;
            background: linear-gradient(to right, #093695, #0d1632);
            border-radius: 0.7rem;
            text-align: center;
          }
        }
      }
      .subject_main_arr_02 {
        width: 48%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .subject_main_arr_02_banckground {
          width: 100%;
          height: 9rem;
        }
        .title {
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          background-color: #ffffff;
          border-radius: 0 0 2rem 2rem;
          padding: 0 0 1rem 1rem;
          .title_01 {
            width: 100%;
            font-size: 0.8rem;
            font-weight: 900;
            padding-bottom: 1rem;
          }
          .title_02 {
            width: 100%;
            font-size: 0.6rem;
            font-weight: 700;
            color: #92969b;
            padding-bottom: 1rem;
          }
          .title_03 {
            width: 2.6rem;
            height: 1.4rem;
            font-size: 0.8rem;
            font-weight: 900;
            color: white;
            background: linear-gradient(to right, #093695, #0d1632);
            border-radius: 0.7rem;
            text-align: center;
          }
        }
      }
    }
  }
  .subject_main_dingzhi {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 34rem;
    .subject_main_title {
      margin: 0 auto;
      position: relative;
      width: 60%;
      height: 3rem;
      .subject_main_title_banckground {
        width: 100%;
        height: 3rem;
        position: absolute;
        bottom: 0px;
      }
      .subject_main_title_info {
        width: 100%;
        height: 1rem;
        font-size: 1.2rem;
        font-weight: 900;
        font-family: Heiti SC;
        position: absolute;
        top: 0rem;
        left: 30%;
      }
    }
    .subject_main_arr {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: 0 1rem;
      .subject_main_arr_element {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        .subject_main_arr_element_01 {
          width: 48%;
          .subject_main_arr_background {
            width: 76%;
            height: 6rem;
            position: relative;
            left: 12%;
            top: 3rem;
          }
          .subject_main_arr_01_01_button {
            width: 100%;
            height: 6.5rem;
            border-radius: 2rem;
            background: linear-gradient(to bottom, #fae6eb, #ffffff);
            padding: 4rem 1rem 0;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            .button_left {
              .button_left_01 {
                font-size: 1rem;
                font-weight: 900;
              }
              .button_left_02 {
                font-size: 0.6rem;
                font-weight: 400;
                color: #92969b;
              }
            }
            .button_right {
              width: 2.6rem;
              height: 1.4rem;
              font-size: 0.8rem;
              font-weight: 900;
              color: white;
              background: linear-gradient(to right, #093695, #0d1632);
              border-radius: 0.7rem;
              text-align: center;
            }
          }
        }
      }
    }
  }
  .subject_main_tuku {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 64rem;
    .subject_main_title {
      margin: 0 auto;
      position: relative;
      width: 60%;
      height: 3rem;
      .subject_main_title_banckground {
        width: 100%;
        height: 3rem;
        position: absolute;
        bottom: 0px;
      }
      .subject_main_title_info {
        width: 100%;
        height: 1rem;
        font-size: 1.2rem;
        font-weight: 900;
        font-family: Heiti SC;
        position: absolute;
        top: 0rem;
        left: 30%;
      }
    }
    .subject_main_arr {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: 0 1rem;
      .subject_main_arr_element {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        .subject_main_arr_element_01 {
          width: 48%;
          .subject_main_arr_background {
            width: 76%;
            height: 6rem;
            position: relative;
            left: 12%;
            top: 3rem;
          }
          .subject_main_arr_01_01_button {
            width: 100%;
            height: 6.5rem;
            border-radius: 2rem;
            background: linear-gradient(to bottom, #fae6eb, #ffffff);
            padding: 4rem 1rem 0;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            .button_left {
              .button_left_01 {
                font-size: 1rem;
                font-weight: 900;
              }
              .button_left_02 {
                font-size: 0.6rem;
                font-weight: 400;
                color: #92969b;
              }
            }
            .button_right {
              width: 2.6rem;
              height: 1.4rem;
              font-size: 0.8rem;
              font-weight: 900;
              color: white;
              background: linear-gradient(to right, #093695, #0d1632);
              border-radius: 0.7rem;
              text-align: center;
            }
          }
        }
      }
    }
  }
  .subject_footer {
    width: 100%;
    position: absolute;
    top: 67rem;
    .checkProgress {
      width: 90%;
      height: 2.8rem;
      border-radius: 1.4rem;
      background-color: white;
      color: #023bb6;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      font-size: 1rem;
      font-weight: 700;
      margin: 0 auto;
    }
  }
  .notice {
    position: absolute;
    top: 72rem;
    left: 1rem;
    font-size: 0.5rem;
    padding: 1rem;
  }
  .version {
    position: absolute;
    top: 78rem;
    left: 2rem;
    font-size: 0.5rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ningboBus/home_ningbo.vue